export class BusinessLogicDefaultResult {
    public errors: string[];
    public get hasErrors(): boolean {
        return this.errors != null && Array.isArray(this.errors) && this.errors.length > 0;
    }

    constructor(errors: string[]) {
        this.errors = errors[0] == undefined || errors[0] == null ? [] : errors;
    }
}
export class BusinessLogicResult<T> {
    public value: T;
    public errors: string[];
    public get hasErrors(): boolean {
        return this.errors != null && Array.isArray(this.errors) && this.errors.length > 0;
    }

    constructor(value: T, errors: string[]) {
        this.value = value;
        this.errors = errors[0] == undefined || errors[0] == null ? [] : errors;
    }
}
export class PageBusinessLogicResult<T> extends BusinessLogicResult<T>{

    public currentPage: number;
    public totalPages: number;
    public totalItems: number;

    constructor(value: T, currentPage: number, totalPages: number, totalItems: number, errors: string[]) {
        super(value, errors);
        this.currentPage = currentPage;
        this.totalPages = totalPages;
        this.totalItems = totalItems;
    }
}